import React from 'react';
import categorybanner1Img from '../../../../assets/images/home/categorybanner1.jpg';
import FloatingHero from '../../../../components/user/general/banner/Banner.js';

const CategoryBanner = () => {
  return (
    <FloatingHero
      title="Equipment Rentals"
      subtitle="Need farm equipment? We're here to help you rent the best machinery easily"
      backgroundImage={categorybanner1Img}
      darkOverlay={0.55} // Overlay kam dark
      titleStyle={{
        color: '#FDB714', // Bright yellow
        textShadow: '2px 2px 8px rgba(0,0,0,0.7), 0 0 10px #FDB714'
      }}
    />
  );
};

export default CategoryBanner;
